import { FunctionComponent } from 'react';

export interface DashboardBannerProps {
  userName?: string;
}

export const DashboardBanner: FunctionComponent<DashboardBannerProps> = ({
  userName = '',
}) => {
  return (
    <div className="w-full">
      <div className="bg-brand-primary section-horizontal-padding py-7">
        <h1 className="text-[2.5rem] font-bold text-white">MyWestminster</h1>
      </div>
      <div className="bg-brand-primary-700 section-horizontal-padding py-4">
        <div className="flex items-center gap-3">
          <span className="text-[2.5rem]">👋</span>
          <div>
            <p className="text-xl font-bold text-white">Welcome {userName}!</p>
            <p className="text-base text-white">
              Stay on top of everything important - report issues, request
              services and manage updates.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
